// baseUrl
export const baseUrl = "https://colleage.vercel.app/"
// export const baseUrl = "http://localhost:8000/"
// get total
export const totalcountapi = `${baseUrl}api/v1/admin/totalcount`;
// login || profile section
export const login = `${baseUrl}api/v1/admin/login`;
export const Signup = `${baseUrl}/api/subAdmin/register`;
export const profileAPi = `${baseUrl}/api/subAdmin/profile`;
export const profileImgAPi = `${baseUrl}/api/subAdmin/addImage`;
export const UpdateNameAPi = `${baseUrl}/api/subAdmin/update`;
// student
export const StudentmeterialcreateApi = `${baseUrl}api/v1/student/uploadpdf`;
export const StudentmeterialListApi = `${baseUrl}api/v1/student/getallpdf`;
export const StudentmeterialupdateApi = `${baseUrl}api/v1/student/updatepdf`;
export const StudentmeterialdeleteApi = `${baseUrl}api/v1/student/deletepdf`;
// addmissoin
export const addmissioncreateApi = `${baseUrl}api/v1/addmission/uploadaddmission`;
export const addmissionListApi = `${baseUrl}api/v1/addmission/getaddmission`;
export const addmissionsingleListApi = `${baseUrl}api/v1//addmission/getsingleaddmission`;
export const addmissionupdateApi = `${baseUrl}api/v1/addmission/updateaddmission`;
export const addmissiondeleteApi = `${baseUrl}api/v1/addmission/deleteaddmission`;

// category
export const categorycreateApi = `${baseUrl}api/v1/category/uploadcategory`;
export const categoryListApi = `${baseUrl}api/v1/category/getcategory`;
export const categoryupdateApi = `${baseUrl}api/v1/category/updatecategory`;
export const categorydeleteApi = `${baseUrl}api/v1/category/deletecategory`;
// blogs
export const getblogAPi = `${baseUrl}api/v1/blogs/getallblogs`
export const createblogAPi = `${baseUrl}api/v1/blogs/uploadblog`
export const getsingleblogApi = `${baseUrl}api/v1/blogs/getSingleBlogs`
export const uploadblogAPi = `${baseUrl}api/v1/blogs/updatelogs`
export const deleteblogApi = `${baseUrl}api/v1/blogs/deleteBlogs`
// news
export const getnewsAPi = `${baseUrl}api/v1/news/getallnews`
export const createnewsAPi = `${baseUrl}api/v1/news/uploadnews`
export const uploadnewsAPi = `${baseUrl}api/v1/news/updatenews`
export const deletenewsApi = `${baseUrl}api/v1/news/deletenews`

// academic
export const getacademincAPi = `${baseUrl}api/v1/acedamic/getacedamic`
export const createacademincAPi = `${baseUrl}api/v1/acedamic/uploadacedamic`
export const uploadacademincAPi = `${baseUrl}api/v1/acedamic/updateacedamic`
export const deleteacademincApi = `${baseUrl}api/v1/acedamic/deleteacedamic`
// topper
export const gettopperAPi = `${baseUrl}api/v1/topper/getalltoppers`
export const createtopperAPi = `${baseUrl}api/v1/topper/uploadtopper`
export const uploadtopperAPi = `${baseUrl}api/v1/topper/updatetopper`
export const deletetopperApi = `${baseUrl}api/v1/topper/deletetoppers`
//course
export const getcourseAPi = `${baseUrl}api/v1/course/getallcourses`
export const createcourseAPi = `${baseUrl}api/v1/course/uploadcourse`
export const uploadcourseAPi = `${baseUrl}api/v1/course/updatecourse`
export const deletecourseApi = `${baseUrl}api/v1/course/deletecourse`
// facilities
export const getfacilitiesAPi = `${baseUrl}api/v1/ficilities/getficilities`
export const createfacilitiesAPi = `${baseUrl}api/v1/ficilities/uploadficilities`
export const uploadfacilitiesAPi = `${baseUrl}api/v1/ficilities/updateficilities`
export const deletefacilitiesApi = `${baseUrl}api/v1/ficilities/deleteficilities`

// Medicalfacilities
export const getMedicalFacilitiesAPi = `${baseUrl}api/v1/medicalficilities/getallmedicalFicilities`
export const createMedicalFacilitiesAPi = `${baseUrl}api/v1/medicalficilities/uploadmedicalficilities`
export const uploadMedicalFacilitiesAPi = `${baseUrl}api/v1/medicalficilities/updatemedicalFicilitiesdetails`
export const deleteMedicalFacilitiesApi = `${baseUrl}api/v1/medicalficilities/deletemedicalFicilities`

// department
export const getdepartmentAPi = `${baseUrl}api/v1/department/getdepartment`
export const createdepartmentAPi = `${baseUrl}api/v1/department/uploaddepartment`
export const uploaddepartmentAPi = `${baseUrl}api/v1/department/updatedepartment`
export const deletedepartmentApi = `${baseUrl}api/v1/department/deletedepartment`
// about us
export const getaboutAPi = `${baseUrl}api/v1/aboutus/getaboutus`
export const createaboutAPi = `${baseUrl}api/v1/aboutus/uploadaboutus`
export const uploadaboutAPi = `${baseUrl}api/v1/aboutus/updateaboutus`
export const deleteaboutApi = `${baseUrl}api/v1/aboutus/deleteaboutus`
// image
export const getimageAPi = `${baseUrl}api/v1/gellery/getallimages`
export const createimageAPi = `${baseUrl}api/v1/gellery/uploadImage`
export const uploadimageAPi = `${baseUrl}api/v1/gellery/updateimage`
export const deleteimageApi = `${baseUrl}api/v1/gellery/deleteimage`
// press
export const getpressAPi = `${baseUrl}api/v1/pressrealse/getallpressrelase`
export const createpressAPi = `${baseUrl}api/v1/pressrealse/uploadpressrealse`
export const uploadpressAPi = `${baseUrl}api/v1/pressrealse/updatpressrealse`
export const deletepressApi = `${baseUrl}api/v1/pressrealse/deletepressimage`
// video
export const getvideoAPi = `${baseUrl}api/v1/video/getallVideo`
export const createvideoAPi = `${baseUrl}api/v1/video/uploadVideo`
export const uploadvideoAPi = `${baseUrl}api/v1/video/updatevideo`
export const deletevideoApi = `${baseUrl}api/v1/video/deleteVideo`
export const updatethumbnailvideoApi = `${baseUrl}api/v1/video/updatethambnail`
// contact us
export const getcontactAPi = `${baseUrl}api/v1/contact/getallcontact`
export const deletecontactApi = `${baseUrl}api/v1/contact/deletecontact`
// complaint
export const getcomplaintAPi = `${baseUrl}api/v1/complaint/getallcomplaint`
export const deletecomplaintApi = `${baseUrl}api/v1/complaint/deletecomplaint`
// student feedback
export const getstudentFeedbackAPi = `${baseUrl}api/v1/studentFeedback/getstudentFeedback`
export const deletestudentFeedbackApi = `${baseUrl}api/v1/studentFeedback/deletestudentFeedback`
export const updatefeedbackApi = `${baseUrl}api/v1/studentFeedback/updatestatus`
//alumni
export const getalumniFeedbackAPi = `${baseUrl}api/v1/aluminFeedback/getalumniFeedback`
export const deletealumniFeedbackApi = `${baseUrl}api/v1/aluminFeedback/deletealumniFeedback`
//teacher
export const getteacherFeedbackAPi = `${baseUrl}api/v1/teacherFeedback/getteacherFeedback`
export const deleteteacherFeedbackApi = `${baseUrl}api/v1/teacherFeedback/deleteteacherFeedback`
//parents
export const getparentsFeedbackAPi = `${baseUrl}api/v1/parentsFeedback/getparentsFeedback`
export const deleteparentsFeedbackApi = `${baseUrl}api/v1/parentsFeedback/deleteparentsFeedback`
//parents
export const getformAPi = `${baseUrl}api/v1/form/getallform`
export const deleteformApi = `${baseUrl}api/v1/form/deleteform`

// notification
export const getnotificationAPi = `${baseUrl}api/v1/notification/getallnotification`
export const deletenotificationApi = `${baseUrl}api/v1/notification/deletenotification`
export const deleteallnotificationApi = `${baseUrl}api/v1/notification/deleteallnotification`
